import React, { useState } from 'react';
import { db } from '../firebase/firestore'; // adjust the path as needed
import { doc, setDoc } from 'firebase/firestore';

const AdminWatchAds = () => {
  const [taskTitle, setTaskTitle] = useState('');
  const [bonusAmount, setBonusAmount] = useState('');
  const [iconUrl, setIconUrl] = useState('');
  const [zoneId, setZoneId] = useState('');

  // টাস্ক সেভ করার ফাংশন
  const saveTask = async () => {
    const taskData = {
      taskTitle,
      bonusAmount,
      iconUrl,
      zoneId,
    };

    const docRef = doc(db, 'Tasks', 'task-1');  // Task ডকুমেন্টে 'task-1' আইডি দিয়ে টাস্ক সেভ
    await setDoc(docRef, taskData);
    
    alert('Task Saved!');
  };

  return (
    <div>
      <h3>Create Task</h3>
      <input
        type="text"
        placeholder="Task Title"
        value={taskTitle}
        onChange={(e) => setTaskTitle(e.target.value)}
      />
      <input
        type="number"
        placeholder="Bonus Amount"
        value={bonusAmount}
        onChange={(e) => setBonusAmount(e.target.value)}
      />
      <input
        type="text"
        placeholder="Icon URL"
        value={iconUrl}
        onChange={(e) => setIconUrl(e.target.value)}
      />
      <input
        type="text"
        placeholder="Zone ID"
        value={zoneId}
        onChange={(e) => setZoneId(e.target.value)}
      />
      <button onClick={saveTask}>Save Task</button>
    </div>
  );
};

export default AdminWatchAds;